// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress-bar[data-v-7d02db02]{border-radius:16px;width:100%;position:relative;height:1.6rem;background:#e2f1f8;margin-bottom:2.4rem}.progress-bar span[data-v-7d02db02]{background:linear-gradient(90deg,#e2f1f8,#4faede);position:absolute;height:1.6rem;top:0;left:0;border-radius:16px}", ""]);
// Exports
module.exports = exports;
